import { useMemo } from 'react';
import { useGetFilesQuery, useGetFilesUrlsQuery } from 'store/services/documentStorage/googleCloudStorage';
import type { FileResponse } from 'types';
import { mergeFilesWithUrls } from '../utils/mergeFilesWithUrls';

type UseFlowFilesDataParams = {
  ids: string[];
  skip?: boolean;
  fallbackFiles?: FileResponse[];
};

export const useFlowFilesData = ({ ids, skip = false, fallbackFiles = [] }: UseFlowFilesDataParams) => {
  const shouldSkip = skip || ids.length === 0;

  const { data: { files = [] } = {}, isFetching: isFetchingFiles } = useGetFilesQuery({ ids }, { skip: shouldSkip });

  const { data: { fileUrls: filesWithUrl = [] } = {}, isFetching: isFetchingUrls } = useGetFilesUrlsQuery({ ids }, { skip: shouldSkip });

  const filesData = useMemo(() => mergeFilesWithUrls(ids, files, filesWithUrl, fallbackFiles), [ids, files, filesWithUrl, fallbackFiles]);

  return {
    filesData,
    isFetching: isFetchingFiles || isFetchingUrls,
  };
};
